import React from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';

const LocationSelector = ({ locations, selectedLocation, onLocationChange, currentLocation }) => {
  return (
    <div className="card border-l-4 border-l-primary">
      <div className="flex items-center gap-4">
        <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
          <Icon name="MapPin" size={24} color="var(--color-primary)" />
        </div>
        
        <div className="flex-1">
          <label className="text-sm font-medium text-muted-foreground mb-2 block">
            Select Gym Location
          </label>
          <Select
            value={selectedLocation}
            onChange={(e) => onLocationChange(e?.target?.value)}
            className="w-full max-w-md"
          >
            {locations?.map(location => (
              <option key={location?.id} value={location?.id}>
                {location?.name} - {location?.city}, {location?.state}
              </option>
            ))}
          </Select>
        </div>

        {currentLocation && (
          <div className="hidden md:flex flex-col items-end gap-1">
            <div className="flex items-center gap-2 text-sm text-foreground font-medium">
              <Icon name="Building2" size={16} />
              {currentLocation?.name}
            </div>
            <div className="text-xs text-muted-foreground">
              {currentLocation?.address}, {currentLocation?.city}
            </div>
            <div className="text-xs text-muted-foreground">
              {currentLocation?.phone}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LocationSelector;